import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Divider } from 'antd';
import { PageRoutes } from '../../../../conf/Global';
import { DataPlatform, RecommendationContent } from '../../../../types.generated';
import { urlEncodeUrn } from '../../../entity/shared/utils';
import { LogoCountCard } from '../../../shared/LogoCountCard';
import { capitalizeFirstLetterOnly } from '../../../shared/textUtil';

type Props = {
    content: Array<RecommendationContent>;
    onClick?: (index: number) => void;
};

export const PlatformList = ({ content, onClick }: Props) => {
    const platformsWithCounts: Array<{ platform: DataPlatform; count?: number }> = content
        .map((cnt) => ({ platform: cnt.entity, count: cnt.params?.contentParams?.count }))
        .filter(
            (platformWithCount) => platformWithCount.platform !== null && platformWithCount !== undefined,
        ) as Array<{ platform: DataPlatform; count?: number }>;
    return (
        <>
            <Divider className="ma-0" />
            <Row className="platform-wrapper">
                {platformsWithCounts.map((platform, index) => (
                    <Col key={platform.platform.urn} xs={24} sm={12} md={8} lg={6}>
                        <Link
                            tabIndex={0}
                            className="f-width-100-xs"
                            to={{
                                pathname: `${PageRoutes.SEARCH}`,
                                search: `?filter_platform=${urlEncodeUrn(platform.platform.urn)}`,
                            }}
                            key={platform.platform.urn}
                            onClick={() => onClick?.(index)}
                        >
                            <LogoCountCard
                                name={
                                    platform.platform.properties?.displayName ||
                                    capitalizeFirstLetterOnly(platform.platform.name) ||
                                    ''
                                }
                                logoUrl={platform.platform.properties?.logoUrl || ''}
                                count={platform.count}
                            />
                        </Link>
                    </Col>
                ))}
            </Row>
            <Divider className="ma-0" />
        </>
    );
};
